import { SystemText } from '@salesperformanceint/e4shared';
import { addMonths, addWeeks, startOfMonth, startOfWeek } from 'helpers/dates';

export const periodOrder = ['Y', 'Q', 'M', 'W'];

export const periodName = (period, short = true) => {
    let result =
        period.indexOf('W') >= 0
            ? 'Week'
            : period.indexOf('M') >= 0
              ? 'Month'
              : period.indexOf('Q') >= 0
                ? 'Quarter'
                : 'Year';
    result = short ? result : `${result}ly`;
    return result;
};

export const periodTrans = period => {
    return SystemText(`General/Periods/${periodName(period || 'M1')}`);
};

export const getValidFor = (period, fyStart) => {
    const start = getPeriodStart(period, fyStart);
    return period === 'Y'
        ? start
        : period === 'Q'
          ? addMonths(start, -3)
          : period === 'M'
            ? addMonths(start, -3)
            : addWeeks(start, -4);
};

export const weekStarts = (past = 52, future = 10) => {
    const start = getPeriodStart('W');
    const dates = [];
    for (let i = future; i > past * -1; i--) {
        dates.push(addWeeks(start, i));
    }

    return dates;
};

export const getPeriodStart = (period, fyStart) => {
    const today = new Date();
    const monday = startOfWeek(today);
    const first = startOfMonth(today);
    let fy = fyStart ? new Date(fyStart) : new Date(today.getFullYear(), 1, 1);
    fy = new Date(today.getFullYear(), fy.getMonth(), fy.getDate());
    fy = fy > today ? addMonths(fy, -12) : fy;
    const mod = fy.getMonth() % 3;
    const quarter =
        first.getMonth() % 3 === mod
            ? first
            : addMonths(first, -1).getMonth() % 3 === mod
              ? addMonths(first, -1)
              : addMonths(first, -2);

    return period === 'Y' ? fy : 'Q' ? quarter : period === 'M' ? first : monday;
};

export const sortGoalsByPeriod = (goals, appendPeriodToName) => {
    let result = goals
        .map(g => ({
            ...g,
            name: appendPeriodToName ? `${periodTrans(g.period)} - ${g.integration} - ${g.name}` : `${g.name}`,
            page: periodOrder.findIndex(o => o === g.period) + 1,
        }))
        .sort((a, b) => (a.page > b.page ? 1 : a.page === b.page ? (a.name > b.name ? 1 : -1) : -1));
    return result;
};
